export function ProblemsSection() {
  const problems = [
    { icon: 'ri-smartphone-line', text: '家で勉強しない、スマホばかり見ている' },
    { icon: 'ri-calendar-close-line', text: 'テスト前しかやらない、計画性がない' },
    { icon: 'ri-file-damage-line', text: '提出物が終わらない、いつも遅れる' },
    { icon: 'ri-question-line', text: '勉強のやり方がわからない' },
    { icon: 'ri-arrow-down-line', text: '成績が下がってきた、特に中2から' },
    { icon: 'ri-book-open-line', text: '数学がわからなくなってきた' },
    { icon: 'ri-time-line', text: '部活が忙しくて勉強時間がない' },
    { icon: 'ri-emotion-unhappy-line', text: 'やる気が出ない、勉強が嫌い' },
    { icon: 'ri-parent-line', text: '親が言っても聞かない、反抗期' },
    { icon: 'ri-alarm-warning-line', text: 'このままで高校受験が心配' }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            こんなお悩み<br className="md:hidden" />ありませんか？
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            中学1年生・中学2年生の保護者様からよく聞くお悩みです
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="bg-white p-5 rounded-xl shadow-md hover:shadow-lg transition-shadow border-l-4 border-orange-500"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-full flex-shrink-0">
                  <i className={`${problem.icon} text-xl text-orange-600`}></i>
                </div>
                <p className="text-sm md:text-base text-gray-700 leading-relaxed pt-1">
                  {problem.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-lg md:text-xl font-bold text-blue-600 mb-2">
            そのお悩み、当塾が解決します！
          </p>
          <p className="text-sm text-gray-600">
            廿日市市の学習塾で、中学生の定期テスト対策と学習習慣づけをサポート
          </p>
        </div>
      </div>
    </section>
  );
}
